import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  title: string;
  message?: string;
}

interface ToastStore {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
}

export const useToast = create<ToastStore>((set) => ({
  toasts: [],
  addToast: (toast) => {
    const id = Math.random().toString(36).substr(2, 9);
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));

    // Auto-remove after 5 seconds
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((t) => t.id !== id),
      }));
    }, 5000);
  },
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));

// Helper functions
export const toast = {
  success: (title: string, message?: string) => {
    useToast.getState().addToast({ type: 'success', title, message });
  },
  error: (title: string, message?: string) => {
    useToast.getState().addToast({ type: 'error', title, message });
  },
  info: (title: string, message?: string) => {
    useToast.getState().addToast({ type: 'info', title, message });
  },
  warning: (title: string, message?: string) => {
    useToast.getState().addToast({ type: 'warning', title, message });
  },
};
